import type { GatewayHelloOk } from "../gateway.ts";
import type { Tab } from "../navigation.ts";
import type { SessionsListResult } from "../types.ts";
import { pickMainSessionForDelegation } from "../chat/resolve-main-session.ts";
import { syncChatComposeDraft } from "../views/chat.ts";
import { getFleetGuideTry } from "./fleet-guide-tries.ts";

export type FleetTryHost = {
  tab: Tab;
  fleetTryByTab: Partial<Record<Tab, string>>;
  chatMessage: string;
  sessionKey: string;
  hello: GatewayHelloOk | null;
  sessionsResult: SessionsListResult | null;
  agentsList?: { defaultId?: string } | null;
  setTab: (tab: Tab) => void;
  setSessionKey: (key: string) => void;
};

export function applyFleetGuideTry(host: FleetTryHost, tryId: string): boolean {
  const def = getFleetGuideTry(tryId);
  if (!def) {
    return false;
  }

  host.fleetTryByTab = { ...host.fleetTryByTab, [def.tab]: tryId };

  if (def.tab === "chat") {
    const defaultAgentId = host.agentsList?.defaultId ?? "main";
    const mainSession = pickMainSessionForDelegation(
      host.hello,
      host.sessionsResult,
      host.sessionKey,
      defaultAgentId,
    );
    if (mainSession !== host.sessionKey) {
      host.setSessionKey(mainSession);
    }
  }

  if (host.tab !== def.tab) {
    host.setTab(def.tab);
  }

  if (def.prefill?.kind === "chat-draft") {
    host.chatMessage = def.prefill.text;
    syncChatComposeDraft(def.prefill.text);
  }

  return true;
}

export function dismissFleetTryForTab(
  fleetTryByTab: Partial<Record<Tab, string>>,
  tab: Tab,
): Partial<Record<Tab, string>> {
  if (!fleetTryByTab[tab]) {
    return fleetTryByTab;
  }
  const next = { ...fleetTryByTab };
  delete next[tab];
  return next;
}

export function activeFleetTryIdForTab(
  fleetTryByTab: Partial<Record<Tab, string>>,
  tab: Tab,
): string | undefined {
  return fleetTryByTab[tab];
}
